import { LinkButton } from "common/components/links/LinkButton";
import { H3 } from "common/components/Typography";
import * as React from "react";
import styles from "./LinkBox.module.css";

interface Props {
  title: string;
  linkText: string;
  to: string;
  content?: React.ReactNode;
  icon?: React.ReactNode;
}

export const LinkBox: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  to,
  content,
  icon,
  linkText,
}) => {
  return (
    <div className={styles.container}>
      {icon && <span className={styles.icon}>{icon}</span>}
      <H3>{title}</H3>
      {content}
      <div className={styles.linkButton}>
        <LinkButton to={to}>{linkText}</LinkButton>
      </div>
    </div>
  );
};
